// Shared by the fan page's three checkouts (song request, tip, playlist):
// the one Stripe.js handle, the customer-facing copy for a failed payment
// creation, and the money-input sanitiser. Split out of pages/RequestPage.tsx.
import { loadStripe } from "@stripe/stripe-js";
import { t } from "../i18n";

export const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
const isSecure = window.location.protocol === "https:" || window.location.hostname === "localhost";
export const stripePromise = STRIPE_PK && isSecure ? loadStripe(STRIPE_PK) : null;

// Customer-facing copy for payment-creation failures. The server's
// ensureDjStripeReady() returns a `code` discriminator alongside the human
// message. For the codes we have specific copy for, we render that here so
// the customer sees situation-aware language ("DJ X is finishing setup —
// try again in a few minutes" beats the generic "Talent not connected to
// Stripe" they'd otherwise see verbatim). For unknown codes we fall back to
// the server's `msg` so this never makes things worse.
export function customerCopyForPayError(err: any, djName: string): string {
  const data = err?.response?.data || {};
  const code: string | undefined = data.code;
  const msg: string | undefined = data.msg;
  const name = djName || t("fanCheckout.thisPerformer");
  switch (code) {
    case "onboarding_incomplete":
      return t("fanCheckout.isFinishingSetupTry", { name });
    case "not_activated":
      return t("fanCheckout.isnTAcceptingTips", { name });
    case "claim_deadline_expired":
      return t("fanCheckout.sAccountNeedsReactivation", { name });
    case "account_frozen":
      return t("fanCheckout.sAccountIsCurrently", { name });
    case "stripe_create_unavailable":
      return t("fanCheckout.paymentProviderIsTemporarily");
    default:
      return msg || err?.message || t("fanCheckout.errorCreatingPayment");
  }
}

// Money input: digits and one dot, two decimals — the bid boxes' onChange.
export const sanitizeMoney = (v: string) => {
  let s = v.replace(",", ".").replace(/[^0-9.]/g, "");
  const parts = s.split(".");
  if (parts.length > 2) s = parts[0] + "." + parts.slice(1).join("");
  if (s.includes(".")) {
    const [a, b] = s.split(".");
    s = a + "." + b.slice(0, 2);
  }
  return s;
};
